module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_07_19_politics_melania-trump-michelle-obama-speech_index.html_plot.9c642aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_07_19_politics_melania-trump-michelle-obama-speech_index.html_plot.png
// module id = 376
// module chunks = 0